import { useState, useEffect, useContext } from "react";
import { AirCoolerContext } from "../context/AirCoolerContext";

function AirCooler({
  tag = "A-101A",
  x = 100,
  y = 100,
  size = 80,
  bladeCount = 3,
  bladeLength = 22,
  rpm = 0,
  baseRPM = 1900,
  onClick,
  style = {}
}) {
  /* =======================
     1. STATE
  ======================= */
  const [angle, setAngle] = useState(0);

  /* =======================
     2. CONTEXT (MUST COME BEFORE USAGE)
  ======================= */
  const ctx = useContext(AirCoolerContext);

  const running = ctx?.coolerData?.[tag]?.running ?? false;

  /* =======================
     3. DERIVED VALUES
  ======================= */
  const speedFactor = running ? rpm / baseRPM : 0;

  /* =======================
     4. EFFECT (ROTATION)
  ======================= */
  useEffect(() => {
    if (!running) return;

    const interval = setInterval(() => {
      setAngle(prev => prev + (2 + speedFactor * 8));
    }, 50);

    return () => clearInterval(interval);
  }, [running, speedFactor]);

  /* =======================
     5. BLADES GENERATION
  ======================= */
  const blades = [];

  for (let i = 0; i < bladeCount; i++) {
    const rotation = (360 / bladeCount) * i;

    blades.push(
      <rect
        key={i}
        x={-3}
        y={-bladeLength}
        width={6}
        height={bladeLength}
        rx={2}
        fill="white"
        transform={`rotate(${rotation})`}
      />
    );
  }

  /* =======================
     6. RENDER
  ======================= */
  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        width: size,
        cursor: "pointer",
        ...style
      }}
      onClick={() => onClick && onClick(tag)}
    >
      <svg width={size} height={size} viewBox="-50 -50 100 100">

        {/* BODY */}
        <circle
          cx="0"
          cy="0"
          r="40"
          fill={running ? "lime" : "red"}
          stroke="black"
          strokeWidth="3"
        />

        {/* BLADES */}
        <g transform={`rotate(${angle})`}>
          {blades}
        </g>

        {/* CENTER */}
        <circle cx="0" cy="0" r="6" fill="black" />
      </svg>

      {/* TAG */}
      <div
        style={{
          textAlign: "center",
          fontSize: "12px",
          color: "black",
          marginTop: "0px",
        }}
      >
        {tag}
      </div>
    </div>
  );
}

export default AirCooler;